module.exports = __webpack_public_path__ + "img/258.9feb853b.jpg";